module.exports = __webpack_public_path__ + "static/media/baseMeme8thumb.31db8f20.jpg";